import classnames from 'classnames';
import React from 'react';
import { InlineIcon } from '../../../inline-icon/inline-icon';
import ChatBigIcon from '../../../../icons/compiled/components/ChatBigIcon';
import ChatSmallIcon from '../../../../icons/compiled/components/ChatSmallIcon';
import DollarIcon from '../../../../icons/compiled/components/DollarIcon';
import FilmIcon from '../../../../icons/compiled/components/FilmIcon';
import InfoIcon from '../../../../icons/compiled/components/InfoIcon';
import ShareIcon from '../../../../icons/compiled/components/ShareIcon';
import SparkIcon from '../../../../icons/compiled/components/SparkIcon';
import TimerIcon from '../../../../icons/compiled/components/TimerIcon';
import styles from './action-button-icon.scss';
export const ACTION_BUTTON_ICONS = {
  share: ShareIcon,
  dollar: DollarIcon,
  film: FilmIcon,
  info: InfoIcon,
  spark: SparkIcon,
  timer: TimerIcon,
  chatBig: ChatBigIcon,
  chatSmall: ChatSmallIcon
};
export const ActionButtonIcon = _ref => {
  let {
    className,
    icon
  } = _ref;
  const Icon = ACTION_BUTTON_ICONS[icon];
  return /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement(InlineIcon, {
    icon: Icon && /*#__PURE__*/React.createElement(Icon, null),
    className: classnames(styles.icon, className)
  }));
};
//# sourceMappingURL=action-button-icon.js.map